export default __webpack_public_path__ + "static/media/Sajek-1.68c5e4f7.jpg";